import { motion } from "framer-motion";
import { VALUE_PROPS } from "./data";

export const WhyPrimeLane = () => {
  return (
    <section id="why-primelane" className="py-20 md:py-32 bg-[#001E52]" data-testid="why-primelane-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-sm text-[#FE6A04] uppercase tracking-widest font-semibold">Why Choose Us</span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white">
            Big-broker reliability. Partner-level attention.
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-300 leading-relaxed">
            PrimeLane is built around what shippers value most: accountability, clear communication, reliable carrier
            coordination, real-time visibility, and cost-conscious freight solutions.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {VALUE_PROPS.map((v, i) => {
            const Icon = v.icon;
            return (
              <motion.div
                key={v.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className="bg-[#001E52] p-8 lg:p-10"
                data-testid={`value-prop-${i}`}
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#FE6A04]">
                  <Icon className="text-white" size={22} />
                </div>
                <h3 className="mt-5 font-heading text-lg font-semibold text-white">{v.title}</h3>
                <p className="mt-2 text-[15px] text-slate-300 leading-relaxed">{v.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
